module.exports = __webpack_public_path__ + "static/media/enabled-player-icon.233962a1.svg";